var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "bid-now",
    },
    [
      _c("div", { staticStyle: { flex: "1 0 0" } }, [
        _c("div", { staticClass: "bid-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "g-line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bid-input-tip",
              staticStyle: { "text-align": "center" },
            },
            [
              _vm._v("\n        Current bid:\n        "),
              _c(
                "span",
                [
                  _c("big-number", { attrs: { number: _vm.currentBid } }),
                  _vm._v(" "),
                  _c("span", [_vm._v("TCash")]),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "unit-input" }, [
          _c("div", { staticClass: "spaceBetween" }, [
            _c("span", { staticClass: "word-sm" }, [
              _c("img", {
                staticStyle: { width: "0.16rem" },
                attrs: {
                  src: require("@/assets/image/placeBid/right-bottom.svg"),
                },
              }),
              _vm._v("1 TCash = $ " + _vm._s(_vm.TCASHPrice)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "word-sm" },
              [
                _vm._v("Balance : "),
                _c("big-number", {
                  attrs: { number: _vm.balance },
                  on: {
                    "update:number": function ($event) {
                      _vm.balance = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spaceBetween exchange-item" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { flex: "1 0 0" } },
              [
                _c("el-input", {
                  staticClass: "exchange-input",
                  attrs: { placeholder: "0.00" },
                  on: { input: _vm.checkNumber, blur: _vm.blurInput },
                  model: {
                    value: _vm.bidNum,
                    callback: function ($$v) {
                      _vm.bidNum = $$v
                    },
                    expression: "bidNum",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-right word-sm-num" }, [
                  _vm._v("$ " + _vm._s(_vm.changeMoney)),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.lastBid
            ? _c(
                "div",
                {
                  staticClass: "bid-input-tip",
                  staticStyle: { "text-align": "right" },
                },
                [
                  _vm._v("\n        My last bid\n        "),
                  _c(
                    "span",
                    {},
                    [
                      _c("big-number", { attrs: { number: _vm.lastBid } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.lastBid
            ? _c("div", { staticClass: "spaceBetween" }, [
                _c("span", { staticClass: "word-sm" }, [_vm._v("After")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "0.22rem",
                        color: "#4C4C4C",
                        "margin-right": "0.08rem",
                      },
                    },
                    [
                      _c("big-number", {
                        attrs: { number: _vm.afterNum },
                        on: {
                          "update:number": function ($event) {
                            _vm.afterNum = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "word-sm" }, [_vm._v("TCash")]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("check-login-btn", {
            staticStyle: { "margin-top": "0.13rem" },
            attrs: {
              label: _vm.submitBtnText,
              disabled: _vm.submitBtnText != "Submit",
            },
            on: {
              clickHandle: _vm.submit,
              "update:label": function ($event) {
                _vm.submitBtnText = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceCenter" }, [
      _c("img", {
        staticStyle: { width: "0.28rem", "margin-right": "0.08rem" },
        attrs: { src: require("@/assets/image/placeBid/place-bid.svg") },
      }),
      _vm._v(" "),
      _c("div", [_vm._v("Place bid")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceLeft unit-icon" }, [
      _c("img", {
        staticStyle: { width: "0.36rem", "margin-right": "0.08rem" },
        attrs: { src: require("@/assets/image/exchange/ustn-nobg.png") },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "word-sm-black" }, [_vm._v("TCash")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }